import { useState } from 'react';
import { useQuery } from 'react-query';
import { endpoints, fetcher } from 'services';

const useCmCode = (param: CodeReqDto) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [cmCodeList, setCmCodeList] = useState<UserCodeListDto[] | any[]>();
  
  /* ======================================================
   * hooks
   * ====================================================== */

  const { isLoading } = useQuery(
    [endpoints.refcode.cmlist, {...param}],
    () => fetcher.refcode.getCmList(param),
    {
      onSuccess: (res: UserCodeListResDto) => {
        switch (res.code) {
          case 200:
            setCmCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  return { isLoading, cmCodeList };
};

export default useCmCode;
